import React from "react";
import "./Price.css";
import WaitingFor from "components/Banner/WaitingFor";
import { ReactComponent as BgLeft } from "images/background/hero-section-left-triangle.svg";
import { ReactComponent as RedShadow } from "images/background/software-solution-graphic-red.svg";
import { ReactComponent as BgRight } from "images/background/left-box-graphic.svg";
import { getData } from "app/data";
import { Link } from "react-router-dom";

export default function Index() {
  return (
    <div className="pricing-page">
      <div className="page-header">
        <div className="contents">
          <BgLeft className="page-header-bg-left" />
          <BgRight className="page-header-bg-right" />
          <RedShadow className="page-header-bg-right-shadow" />

          <div className="text">
            <h2>{getData("pricingData").header.title}</h2>
            <p>{getData("pricingData").header.text}</p>
          </div>
          <div className="custom-button primary">
            <Link to="/request-a-demo">
              {getData("pricingData").header.btn_text}
            </Link>
          </div>
        </div>
      </div>
      <div className="background">
        <div className="contents">
          <div className="pricing-options">
            <div className="header">
              <h2>{getData("pricingData").options.title}</h2>
              <p className="primary text-bold">
                {getData("pricingData").options.sub_title}
              </p>
            </div>
            <div className="cards row">
              {getData("pricingData").options.non_obligation.map(item => {
                return (
                  <div className="col-lg-4 col-sm-6" key={item.id}>
                    <div className="card">
                      <div className={`card-header ${item.btn_color}`}></div>
                      <div className="card-body">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-sub-title">{item.sub_title}</p>
                        <ul className="description">
                          {item.list
                            ? item.list.map(listItem => (
                                <li key={listItem}>{listItem}</li>
                              ))
                            : null}
                        </ul>
                        <div className={`custom-button ${item.btn_color}`}>
                          <Link to={item.btn_link}>{item.btn_text}</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="header">
              <p className="primary text-bold">
                {getData("pricingData").options.monthly_title}
              </p>
            </div>
            <div className="cards d-flex justify-content-center">
              {getData("pricingData").options.monthly.map(item => (
                <div className="card alone" key={item.id}>
                  <div className={`card-header ${item.btn_color}`}></div>
                  <div className="card-body">
                    <h5 className="card-title">{item.title}</h5>
                    <p className="card-sub-title">{item.sub_title}</p>
                    <ul className="description">
                      {item.list
                        ? item.list.map(listItem => (
                            <li key={listItem}>{listItem}</li>
                          ))
                        : null}
                    </ul>
                    <div className={`custom-button alone ${item.btn_color}`}>
                      <Link to={item.btn_link}>{item.btn_text}</Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <hr className="divider" />
      </div>
      <div className="including">
        <BgRight className="includingr-bg-left" />
        <div className="container">
          <div className="header">
            <h3>{getData("pricingData").options.including_fetures_title}</h3>
          </div>
          <div className="row">
            {getData("pricingData").options.including_features.map(item => (
              <div className="col-lg-4 col-sm-6" key={item.id}>
                <div className="item">
                  <div className="img-wrapper">
                    <img src={item.img} alt="goopter benefit" />
                  </div>
                  <div className="text">
                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="small-text text-center">
          <p>{getData("pricingData").options.including_fetures_small_text}</p>
        </div>
      </div>

      <WaitingFor />
    </div>
  );
}
